export default __webpack_public_path__ + "img/fHYutKeC.0a3512b2.svg";